import Index from "../index";
import {StorySection} from "../../utils/storySection";


function sleep(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export async function getStaticPaths() {

    //  list all openers

    const payload = {
        target: 'list-openers',
        'theme': 'erotica',
        "returnText": false,
        'blockSize': 2000,
    }
    const res3 = await fetch('https://mytales.io/api/ml',
        {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: {
                'Content-Type': 'application/json'
            }

        })
    const res4 = await res3.json()
    const openers = res4.data.openers;


    type OpenerType = {
        openerId: string;
        title: string;
    };

    function sanitizeTitleToUrl(title: string) {
        const res = title.replace(/[^a-zA-Z0-9]/g, '-');
        // lowercase the result
        return res.toLowerCase();
    }

    const paths = openers.map((opener: OpenerType) => ({
        params:
            {
                openerId: opener.openerId + '-' + sanitizeTitleToUrl(opener.title),
                title: opener.title
            }
    }));
    console.log('opener paths are', paths)

    return {paths, fallback: false};
}

export async function getStaticProps(context: any) {
    const actualOpenerId = context.params.openerId.split('-')[0];
    // const title = context.params.title;
    if (process.env.NODE_ENV === 'production') {
        console.log('prod env, chilling out before render')
        // avid thundering herd, randomly sleep for 0-30 seconds
        const randSleepMsec = Math.floor(Math.random() * 5000);

        await sleep(randSleepMsec);  // Sleep for 100 msec to make our building not choke
    }

    // get the contents for this openerId
    const inputPayload = {
        target: 'write',
        openerId: actualOpenerId, theme: 'erotica',
        openerOnly: true,
        newStory: true
    }
    var res1
    try {
         res1 = await fetch('https://mytales.io/api/ml',
            {
                method: 'POST',
                body: JSON.stringify(inputPayload),
                headers: {
                    'Content-Type': 'application/json'
                }

            })
    } catch (e) {
         res1 = await fetch('https://mytales.io/api/ml',
            {
                method: 'POST',
                body: JSON.stringify(inputPayload),
                headers: {
                    'Content-Type': 'application/json'
                }

            })
    }


    const res2 = await res1.json()
    console.log('result opener json received succesfully')
    console.log(res2)
    const res = res2.data;
    const title = res.title;

    // @ts-ignore
    const storySection = new StorySection(
        res.sectionId,
        res.text,
        res.imgUrl,
        [res.imgUrl],
        res.endOfStory,
        res.userText
    )
    return {
        props: {
            openerId: actualOpenerId,
            firstSection: storySection.toJSON(),
            title: title
        },
    }
}


export default function OpenerId(props: any) {
    return Index(props)
}